module.exports = __webpack_public_path__ + "assets/img/studyHistory.862e5f37.png";